(() => {
  if (window.lpPortraitFitInitialized) return;
  window.lpPortraitFitInitialized = true;
  const desktop = window.matchMedia('(min-width: 750px)');
  let frame = 0;
  const fit = () => {
    frame = 0;
    const header = document.querySelector('#header-component');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const sticky = document.querySelector('[data-lp-sticky]');
    const bottomSpace = sticky ? Math.max(100, sticky.getBoundingClientRect().height + 24) : 24;
    for (const gallery of document.querySelectorAll('[data-lp-portrait-fit]')) {
      if (!desktop.matches) {
        gallery.style.removeProperty('--lp-portrait-height');
        continue;
      }
      const documentTop = gallery.getBoundingClientRect().top + window.scrollY;
      const topSpace = documentTop < window.innerHeight / 2 ? Math.max(headerHeight, documentTop) : headerHeight + 24;
      gallery.style.setProperty('--lp-portrait-height', `${Math.max(120, window.innerHeight - topSpace - bottomSpace)}px`);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
  const observer = new ResizeObserver(schedule);
  const header = document.querySelector('#header-component');
  if (header) observer.observe(header);
  observer.observe(document.documentElement);
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('variant:update', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();
